import { Col, Row } from "@/utils/bootstrap";
import SvgSortArrow from "./SvgSortArrow";
interface Props {
  title: string;
}
const SortDropdownTitle: React.FC<Props> = ({ title }) => {
  return (
    <Row className="w-100 m-0 d-flex align-items-center">
      <Col className="p-0 d-flex align-items-center col-auto">
        <div>{title}</div>
      </Col>
      <Col className="p-0 d-flex justify-content-end">
        <SvgSortArrow />
      </Col>
    </Row>
  );
};

export default SortDropdownTitle;
